export default __webpack_public_path__ + "static/media/036.cf48ed6c.jpg";